import { render, staticRenderFns } from "./NewTag.vue?vue&type=template&id=82dae58c&"
import script from "./NewTag.vue?vue&type=script&lang=ts&"
export * from "./NewTag.vue?vue&type=script&lang=ts&"
import style0 from "./NewTag.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports